







import VueOptions from '@utils/VueOptions'
import LoadingIndicator from '@components/LoadingIndicator'

settings =
  name: 'AudienceSetShowPage'

  resources:
    audience_listing:
      resourceName: 'audience_listing'
      slug: 'audience_listings/:listingId'

    audience_partnership:
      resourceName: 'audience_partnership'
      slug: 'audience_partnerships/:partnerToken'
      fetch: false

  vue:
    components: { LoadingIndicator }

    computed:
      isLoading: -> !@audience_listing || !@audience_partnership || @requestIsPending
      # listings: -> @audience_listing?.listing_pins || []

      # earliestEvents: -> 
      #   days = @audience_partnership?.earliest_listing || 1
      #   daysAfter = dayjs().add(days,'day')
      #   [...@events]
      #     .filter((e) => dayjs(e.local_start_day).isAfter(daysAfter))
      #     .sort((a,b) ->
      #       isBefore = dayjs(a.local_start_day).isBefore(b.local_start_day)
      #       if isBefore then -1 else 1
      #     )

    watch:
      audience_listing: ->
        @fetch 'audience_partnership'

      audience_partnership : ->
        return unless @audience_listing
        params = { listingId: @audience_listing.id }
        query = { buy_partnership: @$route.params.partnerToken }
        @$router.push({ name: 'AudienceListingShowPage', params, query })

export default VueOptions.vue settings
